import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import {Channels} from 'cl-api';
import InfoDialog, {InfoDialogProps, InfoDialogVariants} from 'cl-dialogs/InfoDialog';
import * as React from 'react';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import InlineButton from '../../InlineButton';
import * as routes from '../../../../App/routeConstants';
import {getCurrentState} from '../../../ActionsManager/EbayListingsActions/currentState';

export interface EnableInventorySyncDialogProps extends InfoDialogProps {
  channel: Channels;
  sellerId: string;
  enableInventorySyncFunction: (quantitySyncEnabled: boolean, id: string) => any;
  inventorySyncIsPaid: boolean;
}

const EnableInventorySyncDialog: React.FunctionComponent<EnableInventorySyncDialogProps> = ({
  channel,
  sellerId,
  enableInventorySyncFunction,
  inventorySyncIsPaid,
  ...props
}) => {
  return (
    <InfoDialog
      title={<>Enable inventory synchronization</>}
      variant={InfoDialogVariants.AreYouSure}
      instructionText={{
        before: (
          <>
            Immediately begin updating the quantities of linked listings on this account with your{' '}
            <InlineButton label="Products Inventory" href={routes.MyAccount.InventoryManagement} />
          </>
        ),
        after: (
          <>
            Not sure yet?{' '}
            <InlineButton
              label="Learn about inventory sync"
              href={getCurrentState().general.supportLinks.supportInventorySync}
            />
          </>
        ),
      }}
      {...props}
      message={
        <>
          Your listings must have SKUs for the Inventory Sync to work.
          <br />
          {channel === Channels.EBay ? (
            <>
              Enabling Inventory Sync will enable the{' '}
              <InlineButton
                style={{color: 'inherit'}}
                href="https://www.ebay.com/help/selling/listings/listing-tips/bulk-listings?id=4160#outofstock"
              >
                Out-of-Stock Feature
              </InlineButton>{' '}
              for this seller account
            </>
          ) : (
            <>
              Enabling Inventory Sync may cause your listings to be ended or closed if your products have no available
              inventory!
            </>
          )}
        </>
      }
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.ENABLE_SYNC]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          additionalActionData={{sellerId, enableInventorySyncFunction, inventorySyncIsPaid}}
        />
      }
    />
  );
};
export default EnableInventorySyncDialog;
